import { FC } from 'react';

import { isNonNullish } from 'remeda';
import useSWR from 'swr';

import { TelegramBotSettingsForm } from './telegramBotSettingsForm/TelegramBotSettingsForm';

import { telegramBotService } from 'v2/api/telegramBotService';
import { Loader } from 'v2/components/loader/Loader';

export const TelegramBotSettings: FC = () => {
  const { data, isLoading, mutate } = useSWR('getTelegramBotSettings', telegramBotService.getTelegramBotSettings);

  if (isLoading) {
    return <Loader />;
  }

  return isNonNullish(data) && <TelegramBotSettingsForm settings={data} onRevalidate={mutate} />;
};
